import React , {useState , useMemo} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPenToSquare,
  faSave,
  faXmark,
  faCheck,
  faFileLines,
  faCloudArrowUp , faArrowUp,
  faArrowDown,
} from '@fortawesome/free-solid-svg-icons';
// import './notification.css';

const CommonTable = ({
  headers,
  rows,
  editRowId,
  editedData,
  handleEdit,
  handleSave,
  handleCancel,
  handleChange,
  editableFields,
  handleLog,
  hideChangeLog,
  fetchData,
  handleUploadImage,
  agencyList,
  countryList,
  brandList , 
  hideAction
}) => {


   // ✅ SORT STATE
    const [sortConfig, setSortConfig] = useState({
      key: null,
      direction: "asc",
    });


     // ✅ HANDLE SORT
      const handleSort = (header) => {
        setSortConfig((prev) => ({
          key: header,
          direction:
            prev.key === header && prev.direction === "asc"
              ? "desc"
              : "asc",
        }));
      };
    
      // ✅ SORTED ROWS
      const sortedRows = useMemo(() => {
        let sorted = [...rows];
    
        if (!sortConfig.key) return sorted;
    
        sorted.sort((a, b) => {
          const aVal = a[sortConfig.key] === true ? 1 : 0;
          const bVal = b[sortConfig.key] === true ? 1 : 0;
    
          if (sortConfig.direction === "asc") {
            return bVal - aVal; // true first
          } else {
            return aVal - bVal; // false first
          }
        });
    
        return sorted;
      }, [rows, sortConfig]);



  return (
    <div className="tableContainer max-w-full w-[90vw]">
      <table className="table text-xs w-[88vw]" role="table">
        <thead className="stickyHeader bg-[var(--mainCol)] text-white" style={{ zIndex: 9 }}>
          <tr>
            {headers?.map((header, index) => (
              <th className="p-1 text-left border" key={index}>
                 <div className="flex items-center gap-1"> 

               
                {header.toUpperCase()}

                 {/* ✅ SORT ICON */}
                                    {(
                                      header === "is_read" ||
                                      header === "status" ||
                                      header === "is_Start" ||
                                      header === "is_Finshed"||
                                     header === "is_Expired" ||
                                      header === "is_shared" ||
                                       header === "is_WSC_active" ||
                                      header === "is_WUC_active" ||
                                      header === "is_used" 
                                    ) && (
                                      <div
                                        className="ml-1 cursor-pointer flex items-center"
                                        onClick={() => handleSort(header)}
                                      >
                                        <FontAwesomeIcon
                                          icon={
                                            sortConfig.key === header &&
                                            sortConfig.direction === "asc"
                                              ? faArrowUp
                                              : faArrowDown
                                          }
                                          className="text-[12px] text-white"
                                        />
                                      </div>
                                    )}
                  </div>
              </th>
            ))}
          { !hideAction &&( <th
              style={{ background: "var(--mainCol)" }}
              className="p-1 text-left border stickyActionColumn z-100"
            >
              ACTION
            </th>)
            }
          </tr>
        </thead>
        <tbody>
          {sortedRows?.map((row , index) => { 

           // ✅ ADD IT HERE (inside map, before return)
          const positionClass =
            index < 2
              ? "tooltipDown"
              : index >= rows.length - 2
              ? "tooltipUp"
              : "";
           return (
            <tr key={row.id}>
              
              {headers.map((header) => (
                <td key={header} className="p-3 border">
                  {editRowId === row.id && editableFields?.includes(header) ? (
                    header === 'active' || header === 'status' || header === 'is_read' ||
                    header === 'is_Finshed' || header === 'is_Start' ||header === 'is_WSC_active' || header === 'is_WUC_active' || header === 'queryResolve' ? (
                      <div className="cursor-pointer flex justify-center">
                        {editedData[header] === true && (
                          <FontAwesomeIcon onClick={(e) => handleChange(e, header, true)} color="var(--green_Main)" icon={faCheck} />
                        )}
                        {editedData[header] === false && (
                          <FontAwesomeIcon onClick={(e) => handleChange(e, header, false)} color="indianred" icon={faXmark} />
                        )}
                      </div>
                    ) : header === "agency" ? (
                      <select
                        value={editedData[header] || ''}
                        onChange={(e) => handleChange(e, header)}
                        className="w-full p-1 border"
                      >
                        <option value="">Select Agency</option>
                        {agencyList?.map((agency, idx) => (
                          <option key={idx} value={agency.agencyName}>
                            {agency.agencyName}
                          </option>
                        ))}
                      </select>
                    ) : header === "brand" ? (
                      <select
                        value={editedData[header] || ''}
                        onChange={(e) => handleChange(e, header)}
                        className="w-full p-1 border"
                      >
                        <option value="">Select Brand</option>
                        {brandList?.map((brand, idx) => (
                          <option key={idx} value={brand?.name}>
                            {brand?.name}
                          </option>
                        ))}
                      </select>
                    ) : header === "country" ? (
                      <select
                        value={editedData[header] || ''}
                        onChange={(e) => handleChange(e, header)}
                        className="w-full p-1 border"
                      >
                        <option value="">Select Country</option>
                        {countryList?.map((country, idx) => (
                          <option key={idx} value={country.title}>
                            {country.title}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input
                        type="text"
                        value={editedData[header] || ''}
                        onChange={(e) => handleChange(e, header)}
                        onKeyUp={(e) => e.key === 'Enter' && handleSave()}
                        className="w-full p-1 border"
                      />
                    )
                  ) : (
                    row[header] === true ? (
                      <FontAwesomeIcon className="ml-2" color="var(--green_Main)" icon={faCheck} />
                    ) : row[header] === false ? (
                      <FontAwesomeIcon className="ml-2" color="indianred" icon={faXmark} />
                    ) : header === "productImage" && row[header] ? (
                      <>
                        <img
                          src={row[header]}
                          alt="background"
                          className="max-h-16 max-w-[120px] object-contain mx-auto"
                        />
                        <label htmlFor={`fileUpload-${row.id}`} className="text-center text-nowrap mt-10 cursor-pointer">
                          <FontAwesomeIcon icon={faCloudArrowUp} /> Upload new Image
                        </label>
                        <input
                          id={`fileUpload-${row.id}`}
                          type="file"
                          accept="image/*"
                          onChange={(e) => handleUploadImage(row, e.target.files[0])}
                          className="mb-3 hidden"
                        />
                      </>
                 ) : header === "body" && row[header] ? (
                <div className={`tooltipParent ${positionClass}`}>
                  <span className="tooltipText">
                    See more
                  </span>

                  <div className="customTooltip">
                    {row[header]}
                  </div>
                </div>
                  ) : (
                    String(row[header])
                  )
                  )}
                </td>
              ))}
             {!hideAction &&( <td className="p-2 border stickyActionColumn">
                {editRowId === row.id ? (
                  <div className="flex justify-center">
                    <FontAwesomeIcon
                      className="p-2 cursor-pointer"
                      color="#67a97b"
                      onClick={handleSave}
                      icon={faSave}
                    />
                    <FontAwesomeIcon
                      className="p-2 cursor-pointer"
                      color="indianred"
                      onClick={handleCancel}
                      icon={faXmark}
                    />
                  </div>
                ) : (
                  <div className="flex justify-center z-100">
                    <FontAwesomeIcon
                      className="cursor-pointer"
                      onClick={() => handleEdit(row.id)}
                      icon={faPenToSquare}
                    />
                    {!hideChangeLog && (
                      <FontAwesomeIcon
                        className="ml-2 cursor-pointer"
                        onClick={() => handleLog(row.id)}
                        icon={faFileLines}
                      />
                    )}
                  </div>
                )}
              </td>)}
            </tr>
          )})}
        </tbody>
      </table>
    </div>
  );
};

export default CommonTable;
